// extracted by mini-css-extract-plugin
export default {"shader":"NHdKM","shaderTitle":"F_TZg","thumbnail":"UPH8O","tablet":"f5lS0","desktop":"Mka9Q","pipsCount1":"xO74e","pipsCount2":"oi89R","pipsCount3":"QPaNm"};